import { EEarlyAccessActionTypes } from 'shared/actions/earlyAccess';
import { IAppState, TActions } from 'shared/common/state';

export const earlyAccessReducer = (state: IAppState, action: TActions): IAppState => {
  switch (action.type) {
    case EEarlyAccessActionTypes.SetEarlyAccessData: {
      return {
        ...state,
        earlyAccessData: action.payload,
      };
    }
    default:
      return state;
  }
};
